<template>
	<BaseModal :title="t('title')" v-model="model" noPadding>
		<div class="px-5">
			<div class="text-label-secondary -mt-2 px-3 text-center text-sm">
				{{ t('desc1') }}
			</div>
			<div class="text-label-secondary mt-2 px-3 text-center text-sm">
				{{ t('desc2') }}
			</div>
		</div>
		<BottomActionsModal class="mt-5 pt-4">
			<BaseButton size="lg" color="primary" class="w-full" @click="contact()">
				{{ t('contact') }}
			</BaseButton>
		</BottomActionsModal>
	</BaseModal>
</template>
<script setup lang="ts">
import BaseModal from './BaseModal.vue'
import BaseButton from '../BaseButton.vue'
import { useI18n } from 'vue-i18n'
import BottomActionsModal from '../BottomActionsModal.vue'
import { WebApp } from '@grammyjs/web-app'

const { t } = useI18n({
	messages: {
		en: {
			title: 'open beta',
			desc1:
				'If you see this message, you’re early - and it really means a lot to us!',
			desc2:
				'There might be some bugs here and there, so please report any issues you encounter to help us improve the experience.',
			contact: 'Contact Support'
		},
		ru: {
			title: 'открытая бета',
			desc1:
				'Если видишь это сообщение, значит ты с нами с самого начала - и это реально много для нас значит!',
			desc2:
				'Возможно, будут встречаться баги, поэтому, пожалуйста, сообщай о любых проблемах, чтобы помочь нам улучшить опыт.',
			contact: 'Написать поддержке'
		}
	}
})

const model = defineModel<boolean>()

const close = () => {
	model.value = false
}

const contact = () => {
	close()

	WebApp.openTelegramLink('https://t.me/ragegift?direct')
}
</script>
